import {
  AddIcon,
  Button,
  Card,
  CircularProgress,
  EmptyState,
  PhoneIcon,
  Stack,
  Tag,
  Typography,
} from '@all-manager/design-system-v2';
import AddUpdateContactModal from '../AddUpdateContactModal/AddUpdateContactModal';
import ContactCard from '../ProviderDetails/ContactCard/ContactCard';
import { useProviderContactsSidebar } from './useProviderContactsSidebar';

type Props = {
  providerId: string;
};

export default function ProviderContactsSidebar(props: Props) {
  const hook = useProviderContactsSidebar({ providerId: props.providerId });

  return (
    <Stack spacing={2} data-testid="provider-contacts-sidebar">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6">
            Contacts
          </Typography>
          <Tag label={hook.count} color="default" />
        </Stack>
        {hook.isAdmin && (
          <Button
            variant="text"
            size="small"
            color="default"
            startIcon={<AddIcon />}
            onClick={hook.handleOpenAddModal}
          >
            Ajouter
          </Button>
        )}
      </Stack>

      {hook.isLoading ? (
        <Stack alignItems="center">
          <CircularProgress aria-label="Chargement des contacts" />
        </Stack>
      ) : hook.contacts.length === 0 ? (
        <Card>
          <EmptyState
            icon={<PhoneIcon fontSize="medium" color="disabled" />}
            title="Aucun contact"
            subtitle="Ajoutez un interlocuteur pour le joindre directement."
            action={
              hook.isAdmin ? (
                <Button
                  variant="text"
                  size="small"
                  color="default"
                  startIcon={<AddIcon />}
                  onClick={hook.handleOpenAddModal}
                >
                  Ajouter un contact
                </Button>
              ) : undefined
            }
          />
        </Card>
      ) : (
        <Stack spacing={1}>
          {hook.contacts.map((contact) => (
            <ContactCard key={contact.id} contact={contact} />
          ))}
        </Stack>
      )}

      {hook.isAddModalOpen ? (
        <AddUpdateContactModal
          providerId={props.providerId}
          onClose={hook.handleCloseAddModal}
        />
      ) : null}
    </Stack>
  );
}
